require('./aggregatorInvestmentBox.scss');

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// @components
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { AggregatorGenericBox } from '../aggregatorGenericBox/aggregatorGenericBox';
import { AggregatorInvestmentDetails } from 'components/aggregator/aggregatorDetails/aggregatorInvestmentDetails/aggregatorInvestmentDetails';

// @helpers
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

// @constants
import { FUND, PENSIONPLAN, SHARES } from 'constants/aggregator/subtypes';

const { FormattedText } = require('core/i18n').i18n;

class AggregatorInvestmentBox extends React.PureComponent {
  renderSubtype = subtype => {
    const { key, investments, isTinkAggregator } = this.props;

    const balanceBySubtype = investments.getIn(['subproducts', subtype, 'balance']);
    const productsBySubtype = investments.getIn(['subproducts', subtype, 'items'], { size: 0 });
    const numberOfProducts = productsBySubtype.size;

    return (
      <AggregatorGenericBox
        header={this.renderHeader(subtype, balanceBySubtype, numberOfProducts, key)}
        body={this.renderBody(productsBySubtype, subtype, isTinkAggregator)}
      />
    );
  };

  renderHeader = (subtype, balance, numberOfProducts, key) => {
    const plainAmountObject = balance && getPlainAmountObject(balance);
    // <i className="icon rebrand-funds" />
    // <i className="icon rebrand-wallets" />
    // <i className="icon rebrand-plans" />
    const iconMap = {
      [FUND]: 'rebrand-funds',
      [PENSIONPLAN]: 'rebrand-plans',
      [SHARES]: 'rebrand-wallets',
    };

    return (
      <div className="aggregator-investment-box-header" id={subtype} key={key}>
        <section>
          <div className="clearfix">
            <div className="pull-left">
              <i className={`aggregator-investment-box-header__icon icon ${iconMap[subtype]}`} />
              <span className="aggregator-investment-box-header__text">
                <FormattedText value={`aggregatorInvestments-${subtype}`} />
              </span>
              <span className="aggregator-investment-box-header__number">({numberOfProducts})</span>
            </div>
            <div className="pull-right">
              <div>
                <FormattedText
                  className="aggregator-investment-box-header__balance-title"
                  value="accordionAccount-balance"
                />
              </div>
              {!!plainAmountObject && (
                <div>
                  <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    className="aggregator-investment-box-header__balance-value"
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  };

  renderBody = (products, subtype, isTinkAggregator) => {
    return (
      <div className="aggregator-investment-box-body">
        <AggregatorInvestmentDetails
          subtype={subtype}
          products={products}
          isTinkAggregator={isTinkAggregator}
        />
      </div>
    );
  };

  render() {
    return (
      <Fragment>
        {this.renderSubtype(FUND)}
        {this.renderSubtype(PENSIONPLAN)}
        {this.renderSubtype(SHARES)}
      </Fragment>
    );
  }
}

AggregatorInvestmentBox.propTypes = {
  key: PropTypes.string,
  investments: PropTypes.object,
  isTinkAggregator: PropTypes.bool,
};

export { AggregatorInvestmentBox };
